// extracted by mini-css-extract-plugin
export default {"Slide_Container":"slide_Slide_Container__EnVOr","carrosel":"slide_carrosel__q9kUO","buttons":"slide_buttons__DwwNY","settado":"slide_settado__uWYSV"};